import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "./useAuth";

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, provisioning } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <main style={styles.viewport}>
        <div role="status" style={styles.status}>
          Loading…
        </div>
      </main>
    );
  }

  // Provisioning: tokens are valid, but the backend hasn't finished
  // writing user/company/membership rows yet. Bounce back to the splash;
  // the splash's "Setting up your account…" state will surface there.
  if (!isAuthenticated) {
    if (provisioning) {
      return <Navigate to="/" replace />;
    }
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}

const styles: Record<string, React.CSSProperties> = {
  viewport: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#fafafa",
  },
  status: {
    fontSize: "0.9375rem",
    color: "#525f7f",
  },
};
